<template>
  <div>
    <v-tooltip bottom v-if="tooltipText">
      <template v-slot:activator="{ on: tooltip }">
        <div v-on="{ ...tooltip }">
          <v-btn
            :class="button1Class"
            :small="button1Small"
            :color="button1Color"
            :icon="button1Icon"
            :disabled="disabled"
            @click.stop="dialog = true"
            v-on="{ ...tooltip }"
          >
            {{ buttonText }}
            <v-icon>{{ buttonIcon }}</v-icon>
          </v-btn>
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <v-btn
      v-else
      :class="button1Class"
      :small="button1Small"
      :color="button1Color"
      :icon="button1Icon"
      :disabled="disabled"
      @click.stop="dialog = true"
    >
      {{ buttonText }}
      <v-icon>{{ buttonIcon }}</v-icon>
    </v-btn>

    <DragForm v-model="dialog">
      <v-card width="500px">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-text-field
                v-model="textField"
                :label="textLable"
                :error-messages="errorMessage"
                v-on:blur="onBlur"
                required
              >
              </v-text-field>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="onCancel">
            {{ cancelText }}
          </v-btn>

          <v-btn color="green darken-1" text @click="onOk">
            {{ okText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>
<script>
import DragForm from '@/components/Forms/DragForm.vue';
export default {
  components: {
    DragForm,
  },
  props: {
    button1Class: {
      type: String,
      default: 'mr-1',
    },
    button1Icon: {
      type: Boolean,
      default: true,
    },
    button1Small: {
      type: Boolean,
      default: true,
    },
    button1Color: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dialogMaxWidth: {
      type: String,
      default: '400px',
    },
    textLable: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      defaultItem: null,
    },
    buttonText: {
      type: String,
      default: '',
    },
    buttonIcon: {
      type: String,
      default: '',
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogText: {
      type: String,
      default: '',
    },
    okText: {
      type: String,
      default: 'Agree',
    },
    cancelText: {
      type: String,
      default: 'Disagree',
    },
  },
  data() {
    return {
      dialog: false,
      textField: '',
      wasBlurred: false,
      okButtonClick: false,
    };
  },
  watch: {
    dialog(flag) {
      if (!flag) this.clear();
    },
  },
  computed: {
    errorMessage() {
      const name = this.textField;
      const check =
        this.executeButtonClick ||
        this.wasBlurred ||
        (name != null && name.length != 0);

      if (!check) return '';

      return this.checkText(name);
    },
  },
  methods: {
    onOk() {
      this.okButtonClick = true;

      if (this.checkText(this.textField).length == 0) {
        this.$emit('ok', this.textField);

        this.dialog = false;
      }
    },
    onCancel() {
      this.$emit('cancel');

      this.dialog = false;
    },
    clear() {
      this.textField = '';
      this.wasBlurred = false;
      this.okButtonClick = false;
    },
    checkText(value) {
      if (value == null || value.length == 0)
        return this.$t('validations.notEmpty');

      return '';
    },
    onBlur() {
      this.wasBlurred = true;
    },
  },
};
</script>
